import proj4 from 'proj4'

/**
 * Transform point coordinates from one coordinate system to another
 * @example
 * ```
 * let wgs84Coordinates = convertCoordinates('EPSG:5174', 'EPSG:4326', [106.35,35.35]);
 * ```
 * @param sourceEpsg source EPSG CODE  For Examples : EPSG:5176
 * @param destEpsg  dest EPSG CODE  For Examples : EPSG:4326
 * @param coordinates input corrdinates For Examples : [lnt,lat]
 * @returns {Object} {x,y}
 */
function convertCoordinates(
  sourceEpsg: string,
  destEpsg: string,
  coordinates: Array<number>,
): { x: number; y: number } {
  const source = proj4.Proj(sourceEpsg)
  const dest = proj4.Proj(destEpsg)

  return proj4.transform(source, dest, coordinates)
}

/**
 * Define a projection
 * @example
 * ```typescript
 * defineProj('EPSG:5179','+proj=tmerc +lat_0=38 +lon_0=127.5 +k=0.9996 +x_0=1000000 +y_0=2000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ');
 * ```
 * @param name EPSG Code. For Examples : EPSG:5176
 * @param define wkt string Foe examples: +proj=tmerc +lat_0=38 +lon_0=129.002890277778 +k=1 +x_0=200000 +y_0=500000 +ellps=bessel +towgs84=-145.907,505.034,685.756,-1.162,2.347,1.592,6.342 +units=m +no_defs +type=crs
 */
function defineProj(name: string, define: string) {
  proj4.defs(name, define)
}

export { convertCoordinates, defineProj }
